// @flow

// Types
import type {
  ReopenJobOperationsById,
} from 'hfty-operator-reopen-job/types'

// Constants
import {
  TREE,
  BRANCH,
} from 'hfty-model-reopen-job'

// Utils
import traverse from 'fc-utils/traverse'

type ReopenJobOperationsSelector = (state: Object) => ReopenJobOperationsById

export default (traverse([TREE, BRANCH]): ReopenJobOperationsSelector)
